/**
 * Destination route coverage for platform ExperienceGate suppression.
 * CommonJS so Node contract tests can require() without Babel.
 */

var pageDestinations = require("./experiencePageDestinations");

var DESTINATION_ROUTE_PATTERNS = pageDestinations.ENTITY_BROWSE_ROUTE_PATTERNS.concat(
  pageDestinations.PAGE_DESTINATION_ROUTES.map(function (entry) {
    return entry.pattern;
  })
);

function normalizePathname(pathname) {
  return pageDestinations.normalizePathname(pathname);
}

/**
 * Mirrors PublicBrowseGate: suppress only when slug resolves to Genres + ExperienceGate.
 * /shop is reserved (ShopReserved). Unknown slugs render not-found.
 */
function isPublicBrowseExperienceSlug(pathname, deps) {
  deps = deps || {};
  var getPublicPageBySlug =
    deps.getPublicPageBySlug ||
    function () {
      return null;
    };
  var isKidsSectionEnabled =
    deps.isKidsSectionEnabled ||
    function () {
      return true;
    };
  var isShopSectionEnabled =
    deps.isShopSectionEnabled ||
    function () {
      return true;
    };

  var path = normalizePathname(pathname);
  var match = path.match(/^\/([^/]+)$/);
  if (!match) {
    return false;
  }

  var slug = match[1];
  var normalized = String(slug).toLowerCase();

  if (normalized === "shop") {
    return false;
  }

  var page = getPublicPageBySlug(slug);
  if (!page) {
    return false;
  }

  if (
    (page.key === "kids" || page.page_type === "KIDS") &&
    !isKidsSectionEnabled()
  ) {
    return false;
  }

  if (
    (page.key === "shop" || page.page_type === "SHOP") &&
    !isShopSectionEnabled()
  ) {
    return false;
  }

  return true;
}

function routeHasDestinationExperienceGate(pathname, deps) {
  var path = normalizePathname(pathname);
  if (
    DESTINATION_ROUTE_PATTERNS.some(function (re) {
      return re.test(path);
    })
  ) {
    return true;
  }
  return isPublicBrowseExperienceSlug(pathname, deps);
}

function destinationTypeForPathname(pathname) {
  return pageDestinations.destinationTypeForPathname(pathname);
}

module.exports = {
  DESTINATION_ROUTE_PATTERNS: DESTINATION_ROUTE_PATTERNS,
  PAGE_DESTINATION_ROUTES: pageDestinations.PAGE_DESTINATION_ROUTES,
  normalizePathname: normalizePathname,
  destinationTypeForPathname: destinationTypeForPathname,
  isPublicBrowseExperienceSlug: isPublicBrowseExperienceSlug,
  routeHasDestinationExperienceGate: routeHasDestinationExperienceGate,
};
